/**
 * @file: remoteChatMsgFromItem.ts
 *
 * Convert a `chat/threads/:id/messages` API row (`ChatThreadMessageItem`)
 * into the domain `RemoteChatMsg`. Pagination rides the response
 * `nextCursor`; the recipient-row `id` is carried for a future context-window
 * fetch. `readers` start empty (they accumulate from `message.read` events /
 * an on-demand fetch).
 */

import { ChatThreadMessageItem, RemoteChatMsg } from '@euler/model/chat';

export function remoteChatMsgFromItem(
  item: ChatThreadMessageItem,
): RemoteChatMsg {
  return {
    kind: 'remote',
    messageId: item.messageId,
    id: item.id,
    roomId: item.roomId,
    authorId: item.authorId,
    authorType: item.authorType,
    authorRole: item.authorRole,
    authorName: item.authorName,
    authorAvatar: item.authorAvatar,
    payloadType: item.payloadType,
    payload: item.payload,
    quoteMessageId: item.quoteMessageId,
    quoteSnapshot: item.quoteSnapshot,
    createdAt: item.createdAt,
    editedAt: item.editedAt,
    deletedAt: item.deletedAt,
    readAt: item.readAt,
    audioPlayedAt: item.audioPlayedAt,
    readByCount: item.readByCount,
    reactions: item.reactions ?? [],
  };
}
